<div class="header-title-section">
<h2>
    <span class="header-breadcrumb" *ngFor="let bread of breadcrumbs"><a [routerLink]="bread.link" [innerHTML]="bread.title">{{bread.title}}</a> <em [hidden]="title==''">>></em> </span>
    <span class="header-title" [innerHTML]="title">{{title}}</span>
</h2>
<p [hidden]="description==''" [innerHTML]="description"></p>
</div>
